import WorkspaceName from './workspace-name';

export default WorkspaceName;
